<!-- Start: Rejwan: 18-05-2026 pf_unified -->
<template>
    <div class="double-scroll-container">
        <div class="double-scroll-top" ref="topScroll" @scroll="handleTopScroll">
            <div :style="{ width: scrollWidth + 'px', height: '1px' }"></div>
        </div>
        <div class="double-scroll-content" ref="content" @scroll="handleBottomScroll">
            <slot></slot>
        </div>
    </div>
</template>

<script>
export default {
    name: 'DoubleScrollWrapper',
    data() {
        return {
            scrollWidth: 0,
            syncingScroll: false
        };
    },
    mounted() {
        this.$nextTick(() => {
            setTimeout(() => {
                this.calculateWidth();
                this.setupObservers();
            }, 200);
        });
    },
    methods: {
        calculateWidth() {
            const content = this.$refs.content;
            if (!content) return;

            const table = content.querySelector('table');
            
            if (table) {
                this.scrollWidth = table.scrollWidth;
            } else {
                this.scrollWidth = content.scrollWidth;
            }
        },
        setupObservers() {
            if (typeof ResizeObserver !== 'undefined') {
                const observer = new ResizeObserver(() => {
                    requestAnimationFrame(() => {
                        this.calculateWidth();
                    });
                });
                
                const content = this.$refs.content;
                const table = content?.querySelector('table');
                
                if (content) observer.observe(content);
                if (table) observer.observe(table);
                
                this._resizeObserver = observer;
            }

            if (typeof MutationObserver !== 'undefined') {
                const observer = new MutationObserver(() => {
                    requestAnimationFrame(() => {
                        this.calculateWidth();
                    });
                });
                
                if (this.$refs.content) {
                    observer.observe(this.$refs.content, {
                        childList: true,
                        subtree: true
                    });
                }
                
                this._mutationObserver = observer;
            }
        },
        handleTopScroll() {
            if (this.syncingScroll) return;
            
            this.syncingScroll = true;
            
            requestAnimationFrame(() => {
                if (this.$refs.content && this.$refs.topScroll) {
                    this.$refs.content.scrollLeft = this.$refs.topScroll.scrollLeft;
                }
                this.syncingScroll = false;
            });
        },
        handleBottomScroll() {
            if (this.syncingScroll) return;
            
            this.syncingScroll = true;
            
            requestAnimationFrame(() => {
                if (this.$refs.topScroll && this.$refs.content) {
                    this.$refs.topScroll.scrollLeft = this.$refs.content.scrollLeft;
                }
                this.syncingScroll = false;
            });
        }
    },
    beforeDestroy() {
        if (this._resizeObserver) {
            this._resizeObserver.disconnect();
        }
        if (this._mutationObserver) {
            this._mutationObserver.disconnect();
        }
    },
    updated() {
        this.$nextTick(() => {
            this.calculateWidth();
        });
    }
};
</script>
<!-- End: Rejwan: 18-05-2026 pf_unified -->
